<template>
  <div>Template</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "courseContent",
  components: {},
  computed: {
    example(): any {
      return true;
    },
  },
  data() {
    return {
      example: -1 as number,
    };
  },
  mounted() {},
  methods: {},
});
</script>

<style></style>
